import styled from "styled-components";
export const DivFormContainer = styled.div`
  padding: 3em 0em 6em 0em;
  @media only screen and (min-width: 768px) {
    padding: 0em 0em 1em 0em;
  }
`;



// WEBPACK FOOTER //
// ./src/payment/styled.js